import { bl_fi_sales_contract_folder_to_fixed_asset_register_link_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class SalesContractFolderFixedAssetLinkContainerModel extends BaseContainerModel {
  bl_fi_sales_contract_folder_to_fixed_asset_register_link: bl_fi_sales_contract_folder_to_fixed_asset_register_link_RowClass =
    new bl_fi_sales_contract_folder_to_fixed_asset_register_link_RowClass();
}
